import api from './api';

export const schoolYearService = {
  getAll: (params?: any) => api.get('/school-years', { params }),
  getById: (id: number) => api.get(`/school-years/${id}`),
  getCurrent: () => api.get('/school-years/current'),
  create: (data: any) => api.post('/school-years', data),
  update: (id: number, data: any) => api.put(`/school-years/${id}`, data),
  delete: (id: number) => api.delete(`/school-years/${id}`),
  activate: (id: number) => api.post(`/school-years/${id}/activate`),
  deactivate: (id: number) => api.post(`/school-years/${id}/deactivate`),
  getSummary: (id: number) => api.get(`/school-years/${id}/summary`)
};